<!-- <main class="main">
  <div class="content">
    <header class="header">
      <nav class="navbar">
        <ul class="nav-links">
          <li><a href="/">Home</a></li>
          <li><a href="/signup">Signup</a></li>
          <li><a href="/login">Login</a></li>
          <li><a href="/referral">Referral</a></li>
        </ul>
      </nav>
    </header>

    <div class="footer">
      <p>Copyright &copy; 2023</p>
      <p>All rights reserved</p>
      <p>Developed by <a href=""target="_blank">Your Name</a></p>
      <p>Powered by <a href="https://angular.io/" target="_blank">Angular</a></p>
    </div>
  </div>
</main> -->
<div class="relative isolate overflow-hidden py-0 h-full">
  <div class="mx-auto">
    <div class="mx-auto max-w-2xl lg:mx-0 lg:max-w-none ">
      <div class="grid grid-cols-1 gap-x-8 gap-y-6 bg-gray-900 p-4 text-base/7 text-white font-semibold sm:grid-cols-2 md:flex lg:gap-x-10">
        <a href="/">Home</a>
        <a href="/signup">Signup</a>
        <a href="/login">Login</a>
        <a href="/referral">Referral</a>
      </div>
      <div class="bg-gray-100 min-h-screen p-4">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
